import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern Living kit — a steel filing cabinet 0.45 x 0.6 x 1.3 with three
// drawer fronts and matte-black bar handles, drawers facing +Z.
const STEEL = "#aab2b8";
const DRAWER = "#b8bfc4";
const HANDLE = "#2e2e30";

export const filingCabinet = defineModel({
  id: "filing-cabinet",
  batchId: "modern",
  name: "Filing cabinet",
  tags: ["modern", "interior", "furniture", "office", "storage", "cabinet"],
  summary: "A steel three-drawer filing cabinet.",
  tiles: { w: 1, h: 1 },
  footprint: 0.7,
  parts(): Part[] {
    const parts: Part[] = [
      // recessed plinth
      { geometry: new THREE.BoxGeometry(0.39, 0.06, 0.5), color: HANDLE, position: [0, 0.03, -0.02] },
      // steel body (front face at z = 0.28)
      { geometry: new THREE.BoxGeometry(0.45, 1.24, 0.56), color: STEEL, position: [0, 0.68, 0] },
    ];
    // three drawer fronts + handles
    for (let i = 0; i < 3; i++) {
      const y = 0.27 + i * 0.4;
      parts.push({
        geometry: new THREE.BoxGeometry(0.39, 0.34, 0.02),
        color: DRAWER,
        position: [0, y, 0.29],
      });
      parts.push({
        geometry: new THREE.BoxGeometry(0.18, 0.03, 0.025),
        color: HANDLE,
        position: [0, y + 0.12, 0.3],
      });
    }
    return parts;
  },
  animations: [],
});
